module.exports = __webpack_public_path__ + "img/chain03.5fd54e1c.png";